import { createDocumentPage, getDocumentTextForType } from "./documentBaseUtils";

export async function generatePrintInspectionHtml(config, data, user, breakNewPage = false) {
    const { getDocumentText } = getDocumentTextForType(data, config);
    const { transport_permission } = data;
    const isCab = transport_permission.cab;
    const isMotocab = transport_permission.motocab;
    const isBus = transport_permission.bus;

    const pages = [];

    pages.push(await createDocumentPage({title: 'DECLARAÇÃO', documentText: getDocumentText('PRIMEIRO_EMPLACAMENTO'), config, data, user}, {showUserName: true}));
    pages.push(await createDocumentPage({title: 'DECLARAÇÃO', documentText: getDocumentText('RENOVACAO_LICENCIAMENTO'), config, data, user}, {showUserName: true}));
    if (isCab) {
        pages.push(await createDocumentPage({title: 'AUTORIZAÇÃO', documentText: getDocumentText('INSTALACAO_TAXIMETRO'), config, data, user}, {showUserName: true}));
        pages.push(await createDocumentPage({title: 'AUTORIZAÇÃO', documentText: getDocumentText('AFERICAO_TAXIMETRO'), config, data, user}, {showUserName: true}));
        pages.push(await createDocumentPage({title: 'AUTORIZAÇÃO', documentText: getDocumentText('ISENCAO_IPI'), config, data, user}, {showChiefSignature: true, showUserName: true}));
        pages.push(await createDocumentPage({title: 'AUTORIZAÇÃO', documentText: getDocumentText('ISENCAO_ICMS'), config, data, user}, {showChiefSignature: true, showUserName: true}));
    }
    if (isCab || isMotocab || isBus) {
        pages.push(await createDocumentPage({title: 'DECLARAÇÃO', documentText: getDocumentText('TRANSFERENCIA_PROPRIEDADE'), config, data, user}, {showUserName: true}));
        pages.push(await createDocumentPage({title: 'DECLARAÇÃO', documentText: getDocumentText('MUDANCA_ALUGUEL'), config, data, user}, {showUserName: true}));
        pages.push(await createDocumentPage({title: 'DECLARAÇÃO', documentText: getDocumentText('MUDANCA_PARTICULAR'), config, data, user}, {showUserName: true}));
    }
    pages.push(await createDocumentPage({title: 'DECLARAÇÃO', documentText: getDocumentText('RENOVACAO_ALVARA'), config, data, user}, {showUserName: true, breakNewPage: breakNewPage}));

    return pages.join('\n');
}
